import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { UiModalHostComponent } from './ui/shell/modal-host/modal-host.component';
import { UiToastHostComponent } from './ui/shell/toast-host/toast-host.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, UiModalHostComponent, UiToastHostComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
